<template>

<el-dialog title="请输入金额" v-model="showView" width="340px"
    :show-close="false"  :before-close="handleClose">

          <div style="background-color:rgba(0,0,0,0.8);color:#FFFFFF;line-height:3rem;" class=" rounded pl-2 text-2xl h-12">
            <p>{{inputVal}}</p>
          </div>

           <div class=" mt-2">
                    <div class="flex items-center ">
                      <el-button   color="#10B981" plain class="num_btn"  round @click="clickNum(1)" size="large"  >1</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(2)" size="large" >2</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(3)" size="large" >3</el-button>
                   <el-button type="warning" plain class="num_btn"  round  @click="clickNum('C')" size="large">C</el-button>
                    </div>
                   <div class="flex items-center " style="margin-top:0.5rem;">
                                          <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(4)" size="large" >4</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(5)" size="large" >5</el-button>
                     <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(6)" size="large">6</el-button>
                   <el-button type="warning" plain class="num_btn"  round  @click="clickNum('.')" size="large">.</el-button>
                    </div>
                   <div class="flex items-center " style="margin-top:0.5rem;">
                        <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(7)" size="large">7</el-button>
                    <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(8)" size="large">8</el-button>
                     <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(9)" size="large" >9</el-button>
                                          <el-button color="#10B981" plain class="num_btn"  round @click="clickNum(0)" size="large" >0</el-button>
                    </div>

          </div>

  <template #footer>

    <span class="dialog-footer flex justify-end items-center" >

   <el-button type="primary" @click="numConfirmEvent">确 定</el-button>
      <el-button @click="numCloseEvent">取 消</el-button>

    </span>

  </template>
</el-dialog>

</template>
<script>
import { ref } from 'vue'
export default {
  name: 'Keyboard',
  props: {
    showView: Boolean
  },
  setup (props, { emit }) {
    const inputVal = ref('')
    const handleClose = () => {}
    const numCloseEvent = () => {
      inputVal.value = ''
      emit('numCloseEvent')
    }
    const numConfirmEvent = () => {
      emit('numConfirmEvent', inputVal.value)
      numCloseEvent()
    }

    const clickNum = (num) => {
      if (num == 'C') {
        inputVal.value = ''
        return
      }
      if (num == '.') {
        if (inputVal.value.split('.').length > 1) {
          return
        }
      }
      inputVal.value = inputVal.value + num
    }

    return {
      handleClose, numCloseEvent, inputVal, clickNum, numConfirmEvent
    }
  }
}
</script>
<style scoped>
.num_btn{
      width:100px;
      font-size:20px;
}
</style>
